import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import RichTextEditor from 'react-rte'
import _ from 'lodash'
import { actions } from '../../redux/modules/templatesActions'
import { actions as proposalActions } from '../../redux/modules/proposalActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import { actions as leadProposalActions } from '../../redux/modules/leadFunctions/leadProposalActions'
import ProposalTemplateForm from '../../components/templates/ProposalTemplateForm'
import { actions as auditActions } from '../../redux/modules/auditActions'
import styled from 'styled-components'
import { message } from 'antd'

const Container = styled.div`
  padding: 25px;
`

const propTypes = {}

class TemplatesProposal extends Component {
  constructor(props) {
    super(props)
    const proposalId = +this.props.match.params.templateId
    this.state = {
      currentKey: 'proposal',
      currentId: proposalId,
      templateOverview: RichTextEditor.createEmptyValue()
    }
  }

  componentWillMount() {
    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })
    this.props.getProposalMilestoneTemplate({ templateId: this.state.currentId })
    this.props.getAllItems()
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.data[0]
        if (loadedTemplate) {
          this.setState({
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            templateOverview: RichTextEditor.createValueFromString(loadedTemplate.overview, 'html')
          })
        }
      }
    }
  }

  handleCreate = formData => {
    const { currentId } = this.state
    const { proposalData, proposalSections, milestones } = formData

    if (currentId === 0) {
      this.props.createTemplate({
        templateType: this.state.currentKey,
        content: proposalData,
        proposalSections: proposalSections,
        milestones: milestones,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: this.state.currentKey,
        content: proposalData,
        proposalSections: proposalSections,
        milestones: milestones,
        userId: this.props.authentication.user.userId
      })
    }
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'proposal'
    })

    message.success('Record deleted.')
    this.setState({
      currentId: 0
    })
  }

  prepareDataStructure = () => {
    const templateSectionsAndItems = _.get(this.props, 'templatesActions.loadedTemplate.data')
    const sections = _.get(templateSectionsAndItems, 'template_sections')
    const items = _.get(templateSectionsAndItems, 'template_items')

    if (sections && sections.length > 0) {
      if (sections.length > 0 && items && items.length > 0) {
        let groupedItems = sections.map((section, index) => {
          section.items = items.filter(item => {
            return item.proposal_section_template_id === section.id
          })
          return section
        })

        // sort by order
        const sortedGroupedItems = _.sortBy(groupedItems, section => {
          const sortedItems = _.sortBy(section.items, item => {
            return item.order
          })

          section.items = sortedItems

          return section.order
        })

        return sortedGroupedItems
      }
    }

    return []
  }

  render() {
    const { currentId } = this.state
    const templateInfo = _.get(this.props, 'templatesActions.loadedTemplate.data.template_info')
    const dataStructure = this.prepareDataStructure()
    const milestonesDataStructure = _.get(
      this.props,
      'proposalActions.proposalMilestonesTemplate.data'
    )
    const items = _.get(this.props, 'itemActions.allItems.data')
    return (
      <Container>
        <ProposalTemplateForm
          currentId={currentId}
          templateInfo={templateInfo}
          dataStructure={dataStructure}
          milestonesDataStructure={milestonesDataStructure}
          items={items || []}
          onCreate={this.handleCreate}
          handleDelete={this.confirmDelete}
        />
      </Container>
    )
  }
}

const mapStateToProps = (
  {
    templatesActions,
    itemActions,
    authentication,
    auditActions,
    leadProposalActions,
    proposalActions
  },
  ownProps
) => ({
  templatesActions,
  itemActions,
  authentication,
  auditActions,
  leadProposalActions,
  proposalActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, actions, itemActions, auditActions, leadProposalActions, proposalActions),
    dispatch
  )
})

TemplatesProposal.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesProposal))



// WEBPACK FOOTER //
// ./src/containers/templates/proposalTemplate.js